/*
 *
 * MeasurementDetails actions
 *
 */

import {
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_DIVISIONS_MEASURE_WATCHER,
  GET_DIVISIONS_MEASURE_SUCCESS,
  GET_DIVISIONS_MEASURE_FAILED,
  GET_QUALITATIVE_QUES_WATCHER,
  GET_QUALITATIVE_QUES_SUCCESS,
  GET_QUALITATIVE_QUES_FAILED,
  GET_DATE_PROG_WATCHER,
  GET_DATE_PROG_SUCCESS,
  GET_DATE_PROG_FAILED,
  EDIT_MEASUREMENT_NAME_WATCHER,
  EDIT_MEASUREMENT_NAME_SUCCESS,
  EDIT_MEASUREMENT_NAME_FAILED,
  DELETE_MEASURE_WATCHER,
  DELETE_MEASURE_SUCCESS,
  DELETE_MEASURE_FAILED,
  RESEND_SURVEY_WATCHER,
  RESEND_SURVEY_SUCCESS,
  RESEND_SURVEY_FAILED,
  COUNT_COLLABORATORS_SUCCESS,
  GET_RECIPIENTS_WATCHER,
  GET_RECIPIENTS_SUCCESS,
  GET_RECIPIENTS_FAILED,
  POST_RECIPIENTS_WATCHER,
  POST_RECIPIENTS_SUCCESS,
  POST_RECIPIENTS_FAILED,
  GET_DATES_WATCHER,
  GET_DATES_SUCCESS,
  GET_DATES_FAILED,
  EDIT_DATES_WATCHER,
  EDIT_DATES_SUCCESS,
  EDIT_DATES_FAILED,
  DOWNLOAD_RECIPIENTS_FAILED,
  DOWNLOAD_RECIPIENTS_SUCCESS,
  DOWNLOAD_RECIPIENTS_WATCHER,
  GET_SURVEYS_TYPE_WATCHER,
  GET_SURVEYS_TYPE_SUCCESS,
  GET_SURVEYS_TYPE_FAILED,
  GET_LEADERS_DETAILS_WATCHER,
  GET_LEADERS_DETAILS_SUCCESS,
  GET_LEADERS_DETAILS_FAILED,
  SEND_TEST_MEASURE_WATCHER,
  SEND_TEST_MEASURE_SUCCESS,
  SEND_TEST_MEASURE_FAILED,
  POST_EXPORT_REPORT_WATCHER,
  DELETE_CD_WATCHER,
  RESEND_CD_WATCHER,
  GET_DIVISIONS_TREE_MEASURE_WATCHER,
  GET_DIVISIONS_TREE_MEASURE_SUCCESS,
  GET_DIVISIONS_TREE_MEASURE_FAILED,
  SET_INCLUDE_SUBDIVISION_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_RECIPIENTS_SEGMENTS_FAILED,
  GET_RECIPIENTS_SEGMENTS_SUCCESS,
  GET_RECIPIENTS_SEGMENTS_WATCHER,
  GET_LEADERS_SEGMENTS_WATCHER,
  GET_LEADERS_SEGMENTS_SUCCESS,
  GET_LEADERS_SEGMENTS_FAILED,
  GET_POSSIBLE_RECIPIENTS_WATCHER,
  GET_POSSIBLE_RECIPIENTS_SUCCESS,
  GET_POSSIBLE_RECIPIENTS_FAILED,
  ADD_COLLABORATORS_WATCHER,
  ADD_COLLABORATORS_SUCCESS,
  ADD_COLLABORATORS_FAILED,
  GET_MEASURE_ENGAGEMENT_WATCHER,
  GET_MEASURE_ENGAGEMENT_SUCCESS,
  GET_MEASURE_ENGAGEMENT_FAILED,
  GET_MEASURE_GENERAL_WATCHER,
  GET_MEASURE_GENERAL_SUCCESS,
  GET_MEASURE_GENERAL_FAILED,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_TOTAL_SUCCESS,
  GET_MEASURE_TOTAL_FAILED,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_INFO_SUCCESS,
  GET_MEASURE_INFO_FAILED,
  GET_DIMENSIONS_RANK_WATCHER,
  GET_DIMENSIONS_RANK_SUCCESS,
  GET_DIMENSIONS_RANK_FAILED,
  GET_DETAIL_COUNTS_WATCHER,
  GET_DETAIL_COUNTS_SUCCESS,
  GET_DETAIL_COUNTS_FAILED,
  GET_MEASURE_RATE_WATCHER,
  GET_MEASURE_RATE_SUCCESS,
  GET_MEASURE_RATE_FAILED,
} from "./constants"

// RESEND COLLABORATORS/DIVISIONS WATCHER
export function resendCollDivWatcher(payload) {
  return {
    type: RESEND_CD_WATCHER,
    payload,
  }
}

// DELETE COLLABORATORS/DIVISIONS WATCHER
export function deleteCollDivWatcher(payload) {
  return {
    type: DELETE_CD_WATCHER,
    payload,
  }
}

// POST EXPORT REPORT WATCHER
export function postExportReportWatcher(payload) {
  return {
    type: POST_EXPORT_REPORT_WATCHER,
    payload,
  }
}

// GET LEADERS DETAILS
export function sendTestMeasureWatcher(payload) {
  return {
    type: SEND_TEST_MEASURE_WATCHER,
    payload,
  }
}

export function sendTestMeasureSuccess(payload) {
  return {
    type: SEND_TEST_MEASURE_SUCCESS,
    payload,
  }
}

export function sendTestMeasureFailed(payload) {
  return {
    type: SEND_TEST_MEASURE_FAILED,
    payload,
  }
}

// GET LEADERS DETAILS
export function getLeadersDetailsWatcher(payload) {
  return {
    type: GET_LEADERS_DETAILS_WATCHER,
    payload,
  }
}

export function getLeadersDetailsSuccess(payload) {
  return {
    type: GET_LEADERS_DETAILS_SUCCESS,
    payload,
  }
}

export function getLeadersDetailsFailed(payload) {
  return {
    type: GET_LEADERS_DETAILS_FAILED,
    payload,
  }
}

// GET SURVEYS TYPE
export function getSurveysTypeWatcher(payload) {
  return {
    type: GET_SURVEYS_TYPE_WATCHER,
    payload,
  }
}

export function getSurveysTypeSuccess(payload) {
  return {
    type: GET_SURVEYS_TYPE_SUCCESS,
    payload,
  }
}

export function getSurveysTypeFailed(payload) {
  return {
    type: GET_SURVEYS_TYPE_FAILED,
    payload,
  }
}

// GET DATES
export function editDatesWatcher(payload) {
  return {
    type: EDIT_DATES_WATCHER,
    payload,
  }
}

export function editDatesSuccess(payload) {
  return {
    type: EDIT_DATES_SUCCESS,
    payload,
  }
}

export function editDatesFailed(payload) {
  return {
    type: EDIT_DATES_FAILED,
    payload,
  }
}

// GET DATES
export function getDatesWatcher(payload) {
  return {
    type: GET_DATES_WATCHER,
    payload,
  }
}

export function getDatesSuccess(payload) {
  return {
    type: GET_DATES_SUCCESS,
    payload,
  }
}

export function getDatesFailed(payload) {
  return {
    type: GET_DATES_FAILED,
    payload,
  }
}

// POST RECIPIENTS
export function postRecipientsWatcher(payload) {
  return {
    type: POST_RECIPIENTS_WATCHER,
    payload,
  }
}

export function postRecipientsSuccess(payload) {
  return {
    type: POST_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function postRecipientsFailed(payload) {
  return {
    type: POST_RECIPIENTS_FAILED,
    payload,
  }
}

// GET RECIPIENTS
export function getRecipientsWatcher(payload) {
  return {
    type: GET_RECIPIENTS_WATCHER,
    payload,
  }
}

export function getRecipientsSuccess(payload) {
  return {
    type: GET_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function getRecipientsFailed(payload) {
  return {
    type: GET_RECIPIENTS_FAILED,
    payload,
  }
}

// GET RECIPIENTS SEGMENTS
export function getRecipientsSegmentsWatcher(payload) {
  return {
    type: GET_RECIPIENTS_SEGMENTS_WATCHER,
    payload,
  }
}

export function getRecipientsSegmentsSuccess(payload) {
  return {
    type: GET_RECIPIENTS_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getRecipientsSegmentsFailed(payload) {
  return {
    type: GET_RECIPIENTS_SEGMENTS_FAILED,
    payload,
  }
}

// GET LEADERS SEGMENTS
export function getLeadersSegmentsWatcher(payload) {
  return {
    type: GET_LEADERS_SEGMENTS_WATCHER,
    payload,
  }
}

export function getLeadersSegmentsSuccess(payload) {
  return {
    type: GET_LEADERS_SEGMENTS_SUCCESS,
    payload,
  }
}

export function getLeadersSegmentsFailed(payload) {
  return {
    type: GET_LEADERS_SEGMENTS_FAILED,
    payload,
  }
}

// COUNT_COLLABORATORS_SUCCESS
export function countCollaboratorsSuccess(payload) {
  return {
    type: COUNT_COLLABORATORS_SUCCESS,
    payload,
  }
}

// DELETE MEASUREMENT
export function resendSurveyWatcher(payload) {
  return {
    type: RESEND_SURVEY_WATCHER,
    payload,
  }
}

export function resendSurveySuccess(payload) {
  return {
    type: RESEND_SURVEY_SUCCESS,
    payload,
  }
}

export function resendSurveyFailed(payload) {
  return {
    type: RESEND_SURVEY_FAILED,
    payload,
  }
}

// DELETE MEASUREMENT
export function deleteMeasureWatcher(payload) {
  return {
    type: DELETE_MEASURE_WATCHER,
    payload,
  }
}

export function deleteMeasureSuccess(payload) {
  return {
    type: DELETE_MEASURE_SUCCESS,
    payload,
  }
}

export function deleteMeasureFailed(payload) {
  return {
    type: DELETE_MEASURE_FAILED,
    payload,
  }
}

// EDIT MEASUREMENT NAME
export function editMeasurementNameWatcher(payload) {
  return {
    type: EDIT_MEASUREMENT_NAME_WATCHER,
    payload,
  }
}

export function editMeasurementNameSuccess(payload) {
  return {
    type: EDIT_MEASUREMENT_NAME_SUCCESS,
    payload,
  }
}

export function editMeasurementNameFailed(payload) {
  return {
    type: EDIT_MEASUREMENT_NAME_FAILED,
    payload,
  }
}

// GET PROGRAMATION DATE
export function getDateProgWatcher(payload) {
  return {
    type: GET_DATE_PROG_WATCHER,
    payload,
  }
}

export function getDateProgSuccess(payload) {
  return {
    type: GET_DATE_PROG_SUCCESS,
    payload,
  }
}

export function getDateProgFailed() {
  return { type: GET_DATE_PROG_FAILED }
}

// GET QUALITATIVE QUESTION
export function getQualitativeQuestionWatcher(payload) {
  return {
    type: GET_QUALITATIVE_QUES_WATCHER,
    payload,
  }
}

export function getQualitativeQuestionSuccess(payload) {
  return {
    type: GET_QUALITATIVE_QUES_SUCCESS,
    payload,
  }
}

export function getQualitativeQuestionFailed() {
  return { type: GET_QUALITATIVE_QUES_FAILED }
}

// GET STATUS WATCHER
export function getDivisionsMeasureWatcher(payload) {
  return {
    type: GET_DIVISIONS_MEASURE_WATCHER,
    payload,
  }
}

export function getDivisionsMeasureSuccess(payload) {
  return {
    type: GET_DIVISIONS_MEASURE_SUCCESS,
    payload,
  }
}

export function getDivisionsMeasureFailed() {
  return { type: GET_DIVISIONS_MEASURE_FAILED }
}

// GET STATUS WATCHER
export function getStatusWatcher(payload) {
  return {
    type: GET_STATUS_WATCHER,
    payload,
  }
}

export function getStatusSuccess(payload) {
  return {
    type: GET_STATUS_SUCCESS,
    payload,
  }
}

export function getStatusFailed() {
  return { type: GET_STATUS_FAILED }
}

export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}

// DOWNLOAD RECIPIENTS
export function downloadRecipientsWatcher(payload) {
  return {
    type: DOWNLOAD_RECIPIENTS_WATCHER,
    payload,
  }
}

export function downloadRecipientsSuccess(payload) {
  return {
    type: DOWNLOAD_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function downloadRecipientsFailed(payload) {
  return {
    type: DOWNLOAD_RECIPIENTS_FAILED,
    payload,
  }
}

// GET DIVISIONS TREE WATCHER
export function getDivisionsTreeMeasureWatcher(payload) {
  return {
    type: GET_DIVISIONS_TREE_MEASURE_WATCHER,
    payload,
  }
}

export function getDivisionsTreeMeasureSuccess(payload) {
  return {
    type: GET_DIVISIONS_TREE_MEASURE_SUCCESS,
    payload,
  }
}

export function getDivisionsTreeMeasureFailed() {
  return { type: GET_DIVISIONS_TREE_MEASURE_FAILED }
}

// SET_INCLUDE_SUBDIVISION_WATCHER
export function setIncludeSubDivisionsWatcher(payload) {
  return {
    type: SET_INCLUDE_SUBDIVISION_WATCHER,
    payload,
  }
}

/* MEASURE RANGE COLOR */
export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}

export function getPossibleRecipientsWatcher(payload) {
  return {
    type: GET_POSSIBLE_RECIPIENTS_WATCHER,
    payload,
  }
}

export function getPossibleRecipientsSuccess(payload) {
  return {
    type: GET_POSSIBLE_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function getPossibleRecipientsFailed() {
  return { type: GET_POSSIBLE_RECIPIENTS_FAILED }
}

export function addCollaboratorsWatcher(payload) {
  return {
    type: ADD_COLLABORATORS_WATCHER,
    payload,
  }
}

export function addCollaboratorsSuccess(payload) {
  return {
    type: ADD_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function addCollaboratorsFailed() {
  return { type: ADD_COLLABORATORS_FAILED }
}

export function getMeasureEngagementWatcher(payload) {
  return {
    type: GET_MEASURE_ENGAGEMENT_WATCHER,
    payload,
  }
}

export function getMeasureEngagementSuccess(payload) {
  return {
    type: GET_MEASURE_ENGAGEMENT_SUCCESS,
    payload,
  }
}

export function getMeasureEngagementFailed() {
  return { type: GET_MEASURE_ENGAGEMENT_FAILED }
}

export function getMeasureGeneralWatcher(payload) {
  return {
    type: GET_MEASURE_GENERAL_WATCHER,
    payload,
  }
}

export function getMeasureGeneralSuccess(payload) {
  return {
    type: GET_MEASURE_GENERAL_SUCCESS,
    payload,
  }
}

export function getMeasureGeneralFailed() {
  return { type: GET_MEASURE_GENERAL_FAILED }
}

export function getMeasureTotalWatcher(payload) {
  return {
    type: GET_MEASURE_TOTAL_WATCHER,
    payload,
  }
}

export function getMeasureTotalSuccess(payload) {
  return {
    type: GET_MEASURE_TOTAL_SUCCESS,
    payload,
  }
}

export function getMeasureTotalFailed() {
  return { type: GET_MEASURE_TOTAL_FAILED }
}

export function getMeasureInfoWatcher(payload) {
  return {
    type: GET_MEASURE_INFO_WATCHER,
    payload,
  }
}

export function getMeasureInfoSuccess(payload) {
  return {
    type: GET_MEASURE_INFO_SUCCESS,
    payload,
  }
}

export function getMeasureInfoFailed(payload) {
  return {
    type: GET_MEASURE_INFO_FAILED,
    payload,
  }
}

export function getDimensionsRankWatcher(payload) {
  return {
    type: GET_DIMENSIONS_RANK_WATCHER,
    payload,
  }
}

export function getDimensionsRankSuccess(payload) {
  return {
    type: GET_DIMENSIONS_RANK_SUCCESS,
    payload,
  }
}

export function getDimensionsRankFailed(payload) {
  return {
    type: GET_DIMENSIONS_RANK_FAILED,
    payload,
  }
}

export function getDetailCountsWatcher(payload){
  return {
    type: GET_DETAIL_COUNTS_WATCHER,
    payload,
  }
}

export function getDetailCountsSuccess(payload){
  return {
    type: GET_DETAIL_COUNTS_SUCCESS,
    payload,
  }
}

export function getDetailCountsFailed(payload){
  return {
    type: GET_DETAIL_COUNTS_FAILED,
    payload,
  }
}


export function getMeasureRateWatcher(payload){
  return {
    type: GET_MEASURE_RATE_WATCHER,
    payload,
  }
}

export function getMeasureRateSuccess(payload){
  return {
    type: GET_MEASURE_RATE_SUCCESS,
    payload,
  }
}

export function getMeasureRateFailed(payload){
  return {
    type: GET_MEASURE_RATE_FAILED,
    payload,
  }
}